import { NextPageContext } from 'next';

export type FetchDeviceInfoResult = {
  isMobile: boolean;
  isDesktop: boolean;
};

export default function fetchDeviceInfo(
  nextPageContext: NextPageContext
): FetchDeviceInfoResult {
  let isMobile = false;
  let isDesktop = false;

  if (nextPageContext.req && nextPageContext.req.headers['user-agent']) {
    isMobile = Boolean(
      nextPageContext.req.headers['user-agent'].match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
      )
    );

    if (!isMobile) {
      isDesktop = true;
    }
  }

  return {
    isMobile,
    isDesktop
  };
}
